// extracted by mini-css-extract-plugin
export default {"notFound":"Home2_notFound__8aXpv","searchResult":"Home2_searchResult__CizNi","pagination":"Home2_pagination__qrEfB","translateButtonBox":"Home2_translateButtonBox__T0SjS"};